import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { RequestUser, User, UserCustomAttribute } from 'shared-types';

const getApplicableUserCustomAttributes = (
  user: Pick<
    User,
    'customAttributes' | 'email' | 'isSelfRegistered' | 'roles'
  > & {
    authenticatorType?: RequestUser['authenticatorType'];
  },
  userCustomAttributes: UserCustomAttribute[]
) => {
  if (!user || !userCustomAttributes?.length) return [];

  const applicableAttributes = userCustomAttributes.filter((attribute) => {
    const conditionsMatch = attribute.conditions?.length
      ? attributesConditionsMatch({
          conditions: attribute.conditions,
          customAttributeValues: user.customAttributes,
          omitCustomAttributes: true,
          user
        })
      : true;

    if (!conditionsMatch) return false;

    if (attribute.appliesTo?.admin && user?.roles.includes('admin')) {
      return true;
    }

    if (
      attribute.appliesTo?.user &&
      user?.roles.includes('user') &&
      !user.roles.includes('admin')
    ) {
      return true;
    }

    if (attribute.appliesTo?.guest && user?.roles.includes('guest')) {
      return true;
    }

    return false;
  });

  return applicableAttributes;
};

export default getApplicableUserCustomAttributes;
